export { default } from './HistoricsSearchForm';
export { default as reducer } from './HistoricsSearchForm.ducks';
